<div class="z-50 grid grid-cols-12 min-h-40 bg-gray-50 place-content-center gap-6 p-4">
        <div class="col-span-12 md:col-start-1 md:col-span-4 lg:col-span-3">
            <span *ngIf="overLabel" class="font-bold text-sm md:text-base text-secondary-400">{{overLabel}}</span>
            <h1 class="text-secondary-500 font-bold text-xl md:text-2xl lg:text-3xl leading-relaxed">{{label}}</h1>
        </div>
        <div *ngIf="hasSearchBar" class="col-span-12">
            <app-search-bar class="w-full" (searchEvent)="onSearch($event)"></app-search-bar>
        </div>
</div>
